var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import { alias } from '@ember/object/computed';
import { isPresent } from '@ember/utils';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { Type, AppVisibility, SellerVisibility } from '@square/dashboard-items-data/models/connect/custom-attribute-definition/data';
import { inject as service } from '@ember/service';
export const SQUARE_APPLICATION_ID = 'Square';
export const MAX_NUM_MERCHANT_CUSTOM_ATTRIBUTE_DEFINITIONS = 10;
export const DEFAULT_NUMBER_PRECISION = 3;
export const MAX_NUMBER_PRECISION = 5;

// ECOM/SO related custom attributes
export const IS_ALCOHOLIC_KEY = 'is_alcoholic';
export const ECOM_GIFTING_ENABLED_KEY = 'ecom_gifting_enabled';
export const ECOM_CUSTOM_ATTRIBUTES = new Set([IS_ALCOHOLIC_KEY, ECOM_GIFTING_ENABLED_KEY]);
let CustomAttributeDefinition = (_dec = attr('string', {
  defaultValue: CatalogObjectType.CUSTOM_ATTRIBUTE_DEFINITION,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/custom-attribute-definition/data'), _dec3 = alias('customAttributeDefinitionData.type'), _dec4 = alias('customAttributeDefinitionData.name'), _dec5 = alias('customAttributeDefinitionData.description'), _dec6 = alias('customAttributeDefinitionData.sourceApplication'), _dec7 = alias('customAttributeDefinitionData.allowedObjectTypes'), _dec8 = alias('customAttributeDefinitionData.displayedObjectTypes'), _dec9 = alias('customAttributeDefinitionData.appVisibility'), _dec10 = alias('customAttributeDefinitionData.sellerVisibility'), _dec11 = alias('customAttributeDefinitionData.stringConfig'), _dec12 = alias('customAttributeDefinitionData.selectionConfig'), _dec13 = alias('customAttributeDefinitionData.numberConfig'), _dec14 = alias('customAttributeDefinitionData.customAttributeUsageCount'), _dec15 = alias('customAttributeDefinitionData.key'), _dec16 = alias('selectionConfig.allowedSelections'), (_class = (_class2 = class CustomAttributeDefinition extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "type", _descriptor2, this);
    _initializerDefineProperty(this, "customAttributeDefinitionData", _descriptor3, this);
    _initializerDefineProperty(this, "attributeType", _descriptor4, this);
    // changed name to avoid collision with object type
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "description", _descriptor6, this);
    _initializerDefineProperty(this, "sourceApplication", _descriptor7, this);
    _initializerDefineProperty(this, "allowedObjectTypes", _descriptor8, this);
    _initializerDefineProperty(this, "displayedObjectTypes", _descriptor9, this);
    _initializerDefineProperty(this, "appVisibility", _descriptor10, this);
    _initializerDefineProperty(this, "sellerVisibility", _descriptor11, this);
    _initializerDefineProperty(this, "stringConfig", _descriptor12, this);
    _initializerDefineProperty(this, "selectionConfig", _descriptor13, this);
    _initializerDefineProperty(this, "numberConfig", _descriptor14, this);
    _initializerDefineProperty(this, "customAttributeUsageCount", _descriptor15, this);
    _initializerDefineProperty(this, "key", _descriptor16, this);
    _initializerDefineProperty(this, "allowedSelections", _descriptor17, this);
  }
  get selectionsByUid() {
    return this.allowedSelections?.toArray().reduce((selectionsByUid, selection) => {
      selectionsByUid.set(selection.uid, selection);
      return selectionsByUid;
    }, new Map());
  }

  // Only used for writing other computed properties more easily.
  // The exact value does not matter as long as when allowedObjectTypes is different, this value is different.
  get flatAllowedObjectTypes() {
    return (this.allowedObjectTypes || []).toArray().join(',');
  }
  get isMerchantDefinition() {
    return this.isNew || this.sourceApplication?.applicationId === SQUARE_APPLICATION_ID;
  }

  /*
   * This property contains a key whose format matches the specification in the ConnectV2 API for CustomAttributeValues.
   * The desired format is "<source application id>:<key>" when the requesting client is different from the source application
   * and "<key>" when the requesting client matches the source application (for dashboard, that ID is 'Square').
   */
  get keyForValues() {
    if (this.sourceApplication?.applicationId === 'Square') {
      return this.key;
    }
    return [this.sourceApplication?.applicationId, this.key].filter(isPresent).join(':');
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/custom-attribute-definition'), _defineProperty(_class2, "Type", Type), _defineProperty(_class2, "AppVisibility", AppVisibility), _defineProperty(_class2, "SellerVisibility", SellerVisibility), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "customAttributeDefinitionData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "attributeType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sourceApplication", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "allowedObjectTypes", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "displayedObjectTypes", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "appVisibility", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sellerVisibility", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "stringConfig", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "selectionConfig", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "numberConfig", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "customAttributeUsageCount", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "key", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "allowedSelections", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { CustomAttributeDefinition as default };